
const digest = 'ad82e47bbebe0a4fca50958d124adb793df9d7225af844070169447c178957c1';
const css = `._commandMenuItem_14z45_1 {
  display: contents; /* Let the natural display of children (implicit in aha-menu-item) take over. */
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"commandMenuItem":"_commandMenuItem_14z45_1"};
export { css, digest };
  